import React, { useEffect, useState } from 'react';
import { getPCItems } from '../services/userservice';
import { gaEvent } from '../utils/GoogleAnalytics/gatracking';
import ListDisplay from '../components/ListDisplay/ListDisplay';
import { showCategoriesCities } from '../services/dwhservices';
import { useGlobalContext } from '../SearchBar/SearchBar';
import {useDwhAppContext } from '../context/DwhContextProvider';

const TopCategories = ({ glid, ak, topProductsCount, topProductsList, selectedTab }) => {

  const [productList, setProductList] = useState("");
  const {paidFree} = useGlobalContext();
  const {topMcatsCities, setTopMcatsCities} = useDwhAppContext();

  const topProducts = async () => {
    let productNames = []
    try {
      const res = await getPCItems(glid, ak);
      topProductsCount(res?.data.length);
      if (res?.data.length) {
        res?.data?.slice(0, 6).map((product_name) => (
          productNames.push(product_name['ITEM_NAME'])
        ))
        setProductList(productNames.join(',   '));
      }
    } catch (error) {
      console.log(error)
    }
  }

  //Redirect users to Weberp DIR IM Listing Page
  const redirectWeberpDIRIMPage = () => {
    gaEvent("Seller Top Products", "Top Products", "click", "Top Products", glid);
    window.open(`https://weberp.intermesh.net/Company/Dir_IMListing.aspx?GLID=${glid}&source=sts`, '_new');
  }

  const displayCategoriesCities = async (rptFlag, isSecondAPI = false) => {
    try {
      const res = await showCategoriesCities(glid, rptFlag);
      if (res?.data?.status_code === 200) {
        const parsedData = JSON.parse(res?.data?.response);
        const sortKey = isSecondAPI ? "total_bl_pur" : "bl_pur_cnt";
        const filteredData = parsedData?.res.filter(item => 
          sortKey === "bl_pur_cnt" ? item.glcat_mcat_name?.toLowerCase() !== "others" : true
        );
        const sortedData = filteredData
          .sort((a, b) => (b[sortKey] || 0) - (a[sortKey] || 0))
          .slice(0, 10); // Get top 10
        return sortedData;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  };


  useEffect(() => {
    if (paidFree === "Paid | ") {
      // Fetch categories/cities only if not already set
      if (!topMcatsCities.mcat || !topMcatsCities.cities) {
        (async () => {
          try {
            const [mcat, cities] = await Promise.all([
              displayCategoriesCities(1),
              displayCategoriesCities(2, true),
            ]);
            setTopMcatsCities({ mcat, cities });
          } catch (error) {
            console.log(error);
          }
        })();
      }
    } else {
      // Call topProducts() only if user is not paid
      topProducts();
    }
  }, [paidFree, glid]); // Depend on paidFree and glid to prevent unnecessary calls


  const displayData = (items, flag) =>
    items?.length > 0 ? items.map(item => (flag === "mcats" ? item["glcat_mcat_name"] : item["city_name"])).join(", ") : "Not Available";

  return (
    <>
      {selectedTab === "8" &&
        (paidFree === "Paid | " ? (
          <>
            {topMcatsCities?.mcat && (
                <ListDisplay
                  title="Top Categories"
                  list={displayData(topMcatsCities?.mcat, "mcats")}
                  onClick={redirectWeberpDIRIMPage}
                />
              )}
            {topMcatsCities?.cities && (
                <ListDisplay
                  title="Preferred Cities"
                  list={displayData(topMcatsCities?.cities, "cities")}
                />
              )}
          </>
        ) : (
          productList.length > 0 && (
            <ListDisplay
              title="Top Products"
              list={productList}
              onClick={redirectWeberpDIRIMPage}
            />
          )
        ))}

      {selectedTab === "7" && topProductsList.length > 0 && (
        <ListDisplay title="Top Categories" list={topProductsList} />
      )}
    </>
  );
};

export default TopCategories;
